<template>
  <div class="d-flex w-100 justify-content-between align-items-center" @click="selectOrder()">
    <div>{{textHeader}}</div>
    <div>
      <span class="caret-order caret-order-asc d-block w-100"
        :class="[currentOrderBy == idHeader && currentOrder == 'ASC' ? 'text-primary' : '']">
        <v-icon name="fa-caret-up" />
      </span>
      <span class="caret-order caret-order-desc d-block w-100"
        :class="[currentOrderBy == idHeader && currentOrder == 'DESC' ? 'text-primary' : '']">
        <v-icon name="fa-caret-down" />
      </span>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ContractFilters',
  props: [
    'textHeader',
    'idHeader',
    'currentOrderBy'
  ],
  data() {
    return {
      currentOrder: '',
    }
  },
  methods: {
    selectOrder() {
      this.currentOrder = this.currentOrder == '' ? 'ASC' : this.currentOrder == 'DESC' ? 'ASC' : 'DESC';
      this.$emit('selectOrder', { order: this.currentOrder, orderBy: this.idHeader });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
